import type { AppDispatch, RootState } from '/business/shared/state/store';
import type { NormaliseErrorInput } from '/shared/functions/normaliseError';

export type GetState = () => RootState;
export type Dispatch = AppDispatch;
export type LegacyDispatch = AppDispatch;

export type ErrorWithContext = {
  context: string;
  error?: NormaliseErrorInput;
  message?: string;
};

export const errorWithContext = (error: NormaliseErrorInput, context: string): ErrorWithContext => {
  if (error && typeof error === 'object') {
    return {
      ...error,
      context,
    };
  }
  return {
    message: String(error),
    context,
  };
};
